declare global {
    interface Window {
        TIER?: string;
    }
}
const TIER = window.TIER;

export interface SiteConfigProps {
    graphqlEndpoint: string;
    bspScriptUrl: string;
    bspHeaderUrl: string;
    bspFooterUrl: string;
    bspSyndicatedUrl: string;
    algoliaAppId: string;
    algoliaApiKey: string;
    algoliaIndex: string;
}

const SiteConfig = ((tier: string): SiteConfigProps => {
    if (tier == 'local') {
        return {
            graphqlEndpoint: 'https://customerapi.staging.sothelabs.com/graphql',
            bspScriptUrl: 'https://bspstage.sothebys.com/react/v2/loader',
            bspHeaderUrl: 'https://bspstage.sothebys.com/react/v2/header',
            bspFooterUrl: 'https://bspstage.sothebys.com/react/v2/footer',
            bspSyndicatedUrl: 'https://bspstage.sothebys.com/syndicate',
            algoliaAppId: 'KAR1UEUPJD',
            algoliaApiKey: '3a0946b15239ae76be48e6d3dee95ef9',
            algoliaIndex: 'bsp_dotcom_staging_en',
        };
    } else if (tier == 'test') {
        return {
            graphqlEndpoint: 'https://customerapi.test.sothelabs.com/graphql',
            bspScriptUrl: 'https://bspstage.sothebys.com/react/v2/loader',
            bspHeaderUrl: 'https://bspstage.sothebys.com/react/v2/header',
            bspFooterUrl: 'https://bspstage.sothebys.com/react/v2/footer',
            bspSyndicatedUrl: 'https://bspstage.sothebys.com/syndicate',
            algoliaAppId: 'KAR1UEUPJD',
            algoliaApiKey: '3a0946b15239ae76be48e6d3dee95ef9',
            algoliaIndex: 'bsp_dotcom_staging_en',
        };
    } else if (tier == 'dev') {
        return {
            graphqlEndpoint: 'https://customerapi.dev.sothelabs.com/graphql',
            bspScriptUrl: 'https://bspstage.sothebys.com/react/v2/loader',
            bspHeaderUrl: 'https://bspstage.sothebys.com/react/v2/header',
            bspFooterUrl: 'https://bspstage.sothebys.com/react/v2/footer',
            bspSyndicatedUrl: 'https://bspstage.sothebys.com/syndicate',
            algoliaAppId: 'KAR1UEUPJD',
            algoliaApiKey: '3a0946b15239ae76be48e6d3dee95ef9',
            algoliaIndex: 'bsp_dotcom_staging_en',
        };
    } else if (tier == 'staging') {
        return {
            graphqlEndpoint: 'https://customerapi.staging.sothelabs.com/graphql',
            bspScriptUrl: 'https://bspstage.sothebys.com/react/v2/loader',
            bspHeaderUrl: 'https://bspstage.sothebys.com/react/v2/header',
            bspFooterUrl: 'https://bspstage.sothebys.com/react/v2/footer',
            bspSyndicatedUrl: 'https://bspstage.sothebys.com/syndicate',
            algoliaAppId: 'KAR1UEUPJD',
            algoliaApiKey: '3a0946b15239ae76be48e6d3dee95ef9',
            algoliaIndex: 'bsp_dotcom_staging_en',
        };
    } else if (tier == 'prod') {
        return {
            graphqlEndpoint: 'https://customerapi.prod.sothelabs.com/graphql',
            bspScriptUrl: 'https://shared.sothebys.com/react/v2/loader',
            bspHeaderUrl: 'https://shared.sothebys.com/syndicate?pageComponent=header',
            bspFooterUrl: 'https://shared.sothebys.com/syndicate?pageComponent=footer',
            bspSyndicatedUrl: 'https://shared.sothebys.com/syndicate',
            algoliaAppId: 'O28SY4Q7WU',
            algoliaApiKey: 'e732e65c70ebf8b51d4e2f922b536496',
            algoliaIndex: 'bsp_dotcom_prod_en',
        };
    } else {
        alert('window.TIER is not set');
        throw new Error('missing window.TIER');
    }
})(TIER);

const TabConfig = ((tier: string): any => {
    if (tier) {
        const index = SiteConfig.algoliaIndex;
        return [
            {
                name: 'objects',
                label: 'Objects',
                filterQuery: 'type:"Bid" OR type:"Buy Now" OR type:"Lot" OR type:"Private Sale" OR type:"Retail"',
                subFilterList: [
                    {
                        component: 'RefinementList',
                        attribute: 'type',
                        label: 'Ways to Buy',
                    },
                    {
                        component: 'DateList',
                        attribute: 'endDate',
                        label: 'Date',
                        description: 'Applies to lots only',
                    },
                    {
                        component: 'PriceRangeSlider',
                        label: 'Price',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'artists',
                        label: 'Creator',
                    },
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_price_desc', label: '$$$ - $' },
                    { value: index + '_price_asc', label: '$ - $$$' },
                    { value: index + '_ending_soonest', label: 'Sale Date' },
                ],
            },
            {
                name: 'auctions',
                label: 'Auctions',
                filterQuery: 'type:"Auction"',
                subFilterList: [
                    {
                        component: 'DateList',
                        attribute: 'endDate',
                        label: 'Date',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'locations',
                        label: 'Location',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'departments',
                        label: 'Department',
                    },
                    /* Temporarily hidden for launch
                    {
                        component: 'RefinementList',
                        attribute: 'auctionType',
                        label: 'Auction Type',
                    },
                    */
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_ending_soonest', label: 'Sale Date' },
                    { value: index + '_alpha_a', label: 'A - Z' },
                    { value: index + '_alpha_z', label: 'Z - A' },
                ],
            },
            {
                name: 'artistsmakers',
                label: 'Artists/Makers',
                filterQuery: 'type:"Artist" OR type:"Brand"',
                subFilterList: [
                    {
                        component: 'RefinementList',
                        attribute: 'type',
                        label: 'Creator Type',
                    },
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_alpha_a', label: 'A - Z' },
                    { value: index + '_alpha_z', label: 'Z - A' },
                ],
            },
            /* Temporarily hidden for launch
            {
                name: 'museums',
                label: 'Museums',
                filterQuery: 'type:"Museum"',
                subFilterList: [
                    {
                        component: 'RefinementList',
                        attribute: 'city',
                        label: 'City',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'country',
                        label: 'Country',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'departments',
                        label: 'Category',
                    },
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_alpha_a', label: 'Alphabetical (A to Z)' },
                    { value: index + '_alpha_z', label: 'Alphabetical (Z to A)' },
                ],
            },
            */
            {
                name: 'events',
                label: 'Events',
                filterQuery:
                    'type:"Art Fair" OR type:"Auction Exhibition" OR type:"Museum Exhibition" OR type:"Selling Exhibition" OR type:"Traveling Exhibition" OR type:"Exhibition" OR type:"S | 2"',
                subFilterList: [
                    {
                        component: 'DateList',
                        attribute: 'endDate',
                        label: 'Date',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'type',
                        label: 'Event Type',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'locations',
                        label: 'Location',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'departments',
                        label: 'Department',
                    },
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_ending_soonest', label: 'Sale Date' },
                    { value: index + '_alpha_a', label: 'A - Z' },
                    { value: index + '_alpha_z', label: 'Z - A' },
                ],
            },
            {
                name: 'editorial',
                label: 'Editorial',
                filterQuery:
                    'type:"Article" OR type:"Art Movement" OR type:"City Guide" OR type:"Page" OR type:"Series" OR type:"Slideshow" OR type:"Video"',
                subFilterList: [
                    {
                        component: 'RefinementList',
                        attribute: 'type',
                        label: 'Content Type',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'locations',
                        label: 'Location',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'departments',
                        label: 'Department',
                    },
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_alpha_a', label: 'A - Z' },
                    { value: index + '_alpha_z', label: 'Z - A' },
                ],
            },
            {
                name: 'contacts',
                label: 'Contacts',
                filterQuery:
                    'type:"Internal Department" OR type:"Sales Department" OR type:"Service" OR type:"Team Member" OR type:"Venue Location"',
                subFilterList: [
                    {
                        component: 'RefinementList',
                        attribute: 'type',
                        label: 'Type',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'locations',
                        label: 'Location',
                    },
                    {
                        component: 'RefinementList',
                        attribute: 'departments',
                        label: 'Department',
                    },
                ],
                sorts: [
                    { value: index, label: 'Relevance' },
                    { value: index + '_alpha_a', label: 'A - Z' },
                    { value: index + '_alpha_z', label: 'Z - A' },
                ],
            },
        ];
    } else {
        alert('window.TIER is not set');
        throw new Error('missing window.TIER');
    }
    return [];
})(TIER);

const TabConfigByName = ((): {} => {
    const tabConfigByName = {};
    TabConfig.forEach((tabConfig) => {
        tabConfigByName[tabConfig.name] = tabConfig;
    });
    return tabConfigByName;
})();

export { SiteConfig };
export { TabConfig };
export { TabConfigByName };
